import React from 'react'

import createBlockTypeButton from './util/createBlockTypeButton';

export default createBlockTypeButton({
  blockType: 'hr',
  children: (
    <i className={"fa fa-minus"} aria-hidden="true"></i>
  ),
});
